export const PRICING_RULE = {
  UPR: "UPR",
  FIRST_LOOK: "FIRST_LOOK",
};

export const STATUS = {
  ALL: "ALL",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const PPFILTER = {
  ALL: "ALL",
  PROTECTED: "PROTECTED",
  PRESERVED: "PRESERVED",
  NOT_PROTECTED_PRESERVED: "NOT_PROTECTED_PRESERVED",
};

export const RULE_FILTER = {
  ALL: "ALL",
  INTOWOW_ONLY: "INTOWOW_ONLY",
  PUBLISHER_ONLY: "PUBLISHER_ONLY",
};

export const PRICE = {
  ALL: "ALL",
  CUSTOM: "CUSTOM",
  BLOCKED: "BLOCKED",
};

export const TYPE_FILTER = {
  ALL: "ALL",
  DISPLAY: "DISPLAY",
  MOBILE: "MOBILE",
  VIDEO: "VIDEO",
};

export const LOG_STATUS = {
  ADDED: "Added",
  ACTIVATE: "Activate",
  DEACTIVATED: "Deactivated",
  CHANGED: "Changed",
};

export const CHANGE_SUMMARY = {
  PRICING_CHANGED: "Pricing Changed",
  TARGETING_CHANGED: "Targeting Changed",
  NAME_CHANGED: "Name Changed",
};

export const ON_STATUS = [LOG_STATUS.ADDED, LOG_STATUS.ACTIVATE];
export const OFF_STATUS = [LOG_STATUS.DEACTIVATED];

export const LOG_STATUS_CHECK = {
  [LOG_STATUS.ADDED]: ({ from, to, title }) =>
    from === "" && to === "Active" && title === "Status",
  [LOG_STATUS.ACTIVATE]: ({ from, to, title }) =>
    from === "Inactive" && to === "Active" && title === "Status",
  [LOG_STATUS.DEACTIVATED]: ({ from, to, title }) =>
    from === "Active" && to === "Inactive" && title === "Status",
};

export const CHANGE_SUMMARY_CHECK = {
  [CHANGE_SUMMARY.PRICING_CHANGED]: ({ title = "", type = "" }) =>
    title.startsWith("Pricing") && type !== "",
  [CHANGE_SUMMARY.TARGETING_CHANGED]: ({ title = "", type = "" }) =>
    title.startsWith("Targeting") && type !== "",
  [CHANGE_SUMMARY.NAME_CHANGED]: ({ title = "", type = "" }) =>
    title === "Name" && type !== "",
};

export const LOG_EXPAND_LENGTH = 3;
